import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

export default function Login({ invitationToken, invitedEmail }) {
  const { data, setData, post, processing, errors } = useForm({
    email: invitedEmail || '',
    password: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/login');
  };

  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      {invitationToken && (
        <div className="mb-6 sm:mx-auto sm:w-full sm:max-w-sm bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">Sign in or create an account to accept the facility invitation.</p>
        </div>
      )}

      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
        </div>
        <h2 className="mt-2 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
        <p className="mt-2 text-center text-sm/6 text-gray-600">
          Don't have an account?{' '}
          <Link
            href={invitationToken ? `/register?invitation_token=${invitationToken}${invitedEmail ? `&email=${encodeURIComponent(invitedEmail)}` : ''}` : '/buy'}
            className="font-semibold text-indigo-600 hover:text-indigo-500"
          >
            Create one
          </Link>
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">Email</label>
            <input
              id="email"
              type="email"
              required
              autoFocus
              autoComplete="email"
              placeholder="Enter your email"
              value={data.email}
              onChange={(e) => setData('email', e.target.value)}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
            {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
          </div>
          <br />
          <div>
            <div className="flex justify-between items-center">
              <label htmlFor="password" className="text-sm/6 font-medium text-gray-900">Password</label>
              <Link href="/password_resets/new" className="text-sm font-semibold text-indigo-600 hover:text-indigo-500">
                Forgot password?
              </Link>
            </div>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              placeholder="Enter your password"
              maxLength={72}
              value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
            {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
            <br />
          </div>
          <div>
            <button
              type="submit"
              disabled={processing}
              className="cursor-pointer flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
            >
              {processing ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>

        {/*
          Staff / contractor magic-link entrances. Kept understated below the
          main form so students (the 99% case) aren't distracted; the people
          who need these links know to look here. Both flows are passwordless —
          the server emails a one-time login link.
        */}
        <div className="mt-8">
          <div className="relative">
            <div className="absolute inset-0 flex items-center" aria-hidden="true">
              <div className="w-full border-t border-gray-200" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white px-2 text-xs uppercase tracking-wide text-gray-500">
                Staff sign-in
              </span>
            </div>
          </div>
          <div className="mt-4 flex justify-center gap-6 text-sm">
            <Link
              href="/instructor/login"
              className="font-medium text-gray-600 hover:text-indigo-600"
            >
              Instructor
            </Link>
            <Link
              href="/reviewer/login"
              className="font-medium text-gray-600 hover:text-indigo-600"
            >
              Reviewer
            </Link>
            <Link
              href="/sales/login"
              className="font-medium text-gray-600 hover:text-indigo-600"
            >
              Sales
            </Link>
          </div>
        </div>
      </div>
      </div>
    </AuthLayout>
  );
}
